import gql from 'graphql-tag';
import { Fragments } from '../fragments';

export const all = gql`
  query SearchQuery($input: Search!) {
    searchEntities(input: $input) {
      ...SearchResult
    }
  }

  ${Fragments.search.searchResult}
`;
